import React, { useState, useEffect } from 'react';
import './Egg.css';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';

/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function EggLearn(props) {
  // Initialize variables to be used later

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const [eggs, setEggs] = useState(true);
  const [egg1, setEgg1] = useState(true);
  const [egg2, setEgg2] = useState(false);
  const [egg3, setEgg3] = useState(false);
  const [effect1, setEffect1] = useState('bounceIcons');
  const [effect2, setEffect2] = useState('');
  const [effect3, setEffect3] = useState('');
  const [displayLearnVideo, setDisplayLearnVideo] = useState(false);
  const [eggNum, setEggNum] = useState(0);
  const [learnVideo, setlearnVideo] = useState('');
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const bounceSound = new Audio(generateImageUrl('media/Module1Videos/button_bouncing.mp3'));
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));
  const egg1Img = generateImageUrl('images/Module18Images/Egg+1.svg');
  const egg2Img = generateImageUrl('images/Module18Images/Egg+2.svg');
  const egg3Img = generateImageUrl('images/Module18Images/Egg+3.svg');
  const nestImg = generateImageUrl('images/Module18Images/Nest.svg');
  const [Exit, setExit] = useState(generateImageUrl('images/Images/close.png'));

  // CSS code for the back button


  const displayVideo = (video, num) => {
    setlearnVideo(video);
    setEggNum(num);
    setEggs(false);
    setDisplayLearnVideo(true);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  useEffect(() => {
    sleep(700).then(() => {
      bounceSound.play()
    });
  }, []);

  // The actual HTML code that determines whether to show the module above.
  return (
    <>
      <div
        className='eggScene'
        style={{ backgroundImage: `url(${props.background})` }}
      >
        <img
          className='back-btn-ftb'
          src={Exit}
          onClick={() => {
            props.setDisplayLearn(false);
          }}
        ></img>
        {displayLearnVideo && (
          <CloudfrontVideoFormat
            source={learnVideo}
            back={'unit4'}
            background={props.background}
            close={()=>{setDisplayLearnVideo(false); setEggs(true);}}
            ended={() => {
              setDisplayLearnVideo(false);
              setEggs(true);
              if (eggNum === 1) {
                setEffect1('');
                setEffect2('bounceIcons');
                setEgg2(true);
                sleep(700).then(() => {
                  bounceSound.play()
                });
              } else if (eggNum === 2) {
                setEffect2('');
                setEffect3('bounceIcons');
                setEgg3(true);
                sleep(700).then(() => {
                  bounceSound.play()
                });
              } else if (eggNum === 3) {
                if (props.module.reviewIcon === false) {
                  dispatch({ type: props.step_completed, payload: 'learn' });
                }
                props.module.sectionCompleted = props.module.sectionCompleted + 1
                props.setDisplayLearn(false);
              }
            }}
          />
        )}
        {eggs && (
          <div className='lizard_Egg'>
            <div className='egg_nest'>
              {<img alt='' className='nestEgg' src={nestImg} />}
              {egg1 && (
                <div
                  className='egg1'
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayVideo(props.learnVideo1, 1);
                    });
                  }}
                >
                  <img alt='' id={effect1} src={egg1Img} />
                </div>
              )}
              {egg2 && (
                <div
                  className='egg2'
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayVideo(props.learnVideo2, 2);
                    });
                  }}
                >
                  <img alt='' className='egg2' id={effect2} src={egg2Img} />
                </div>
              )}
              {egg3 && (
                <div
                  className='egg3'
                  onClick={() => {
                    touchSound.play()
                    sleep(500).then(() => {
                      displayVideo(props.learnVideo3, 3);
                    });
                  }}
                >
                  <img alt='' className='egg3' id={effect3} src={egg3Img} />
                </div>
              )}
            </div>
            {<img alt='' className='animateLizard' src={props.animal} />}
          </div>
        )}
      </div>
    </>
  );
}
